module.exports = __webpack_public_path__ + "img/button-bg-rules-payout.c043e8fa.png";